import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard/auth-guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';
import { RoleGuard } from 'src/auth/guard/role-guard';

import { usePathname } from '../hooks';
import { LayoutCreateJob } from './lazy-layouts';

const CreateJobPage = lazy(() => import('src/pages/create-job'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

const createJobLayout = () => (
  <LayoutCreateJob>
    <SuspenseOutlet />
  </LayoutCreateJob>
);

export function getCreateJobRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  return [
    {
      path: 'create-job',
      element: CONFIG.auth.skip ? (
        createJobLayout()
      ) : (
        <AuthGuard>
          <HRAuthGuard>{createJobLayout()}</HRAuthGuard>
        </AuthGuard>
      ),
      children: [
        {
          element: (
            <RoleGuard action="jobs.create">
              <CreateJobPage />
            </RoleGuard>
          ),
          index: true,
        },
      ],
    },
  ];
}
